<span class="boolean-wrapper" [ngClass]="{'blue': value}"><fa-icon *ngIf="value" [icon]="faCheck"></fa-icon></span>
